(function () {
  'use strict';
  var MOUNT_ID = 'bundle-builder', CONFIG_ID = 'bundle-builder-config';
  var root, cfg, deadline = 0, ticker = null, wasActive = true, state = { tier: 0, picks: [], addons: {} };
  function money(cents) { var c = Math.round(cents); return cfg.moneyFormat ? cfg.moneyFormat.replace('{{amount}}', (c / 100).toFixed(2)) : '$' + (c / 100).toFixed(2); }
  function dealOn() { return !!cfg.deal && Date.now() < deadline; }
  function priceOf(tr) { return dealOn() ? tr.price : (tr.full || tr.price); }
  function tier() { return cfg.tiers[state.tier]; }
  function total() { var sum = priceOf(tier()); (cfg.addons || []).forEach(function (a) { if (state.addons[a.id]) sum += a.price; }); return sum; }
  function pad(n) { return (n < 10 ? '0' : '') + n; }
  function clock(s) { var h = Math.floor(s / 3600), m = Math.floor((s % 3600) / 60), x = s % 60; return (h ? h + ':' + pad(m) : pad(m)) + ':' + pad(x); }
  function stockHtml() { var n = parseInt(cfg.stock, 10) || 0; if (n <= 0) return ''; return '<div class="bbdl__stock"><span class="bbdl__dot"></span>' + (cfg.stockText || 'Low stock: only {n} left').replace('{n}', '<b>' + n + '</b>') + '</div>'; }
  function timerText() {
    if (!cfg.deal) return '';
    if (!dealOn()) return cfg.deal.endedText || 'This bundle deal has ended.';
    var s = Math.max(0, Math.ceil((deadline - Date.now()) / 1000));
    return (cfg.deal.label || 'Bundle deal ends in') + ' <b>' + clock(s) + '</b>';
  }
  function unitOptions(selected) {
    return cfg.variants.map(function (v) {
      return '<option value="' + v.id + '"' + (String(v.id) === String(selected) ? ' selected' : '') + (v.available ? '' : ' disabled') + '>' + v.title + (v.available ? '' : ' — sold out') + '</option>';
    }).join('');
  }
  function render() {
    var on = dealOn(), html = '';
    html += stockHtml();
    if (cfg.deal) html += '<div class="bbdl__deal' + (on ? '' : ' is-over') + '" data-deal>' + timerText() + '</div>';
    if (cfg.label) html += '<p class="bbdl__label">' + cfg.label + '</p>';
    cfg.tiers.forEach(function (tr, i) {
      var sel = i === state.tier, p = priceOf(tr), sub = on ? tr.subtitle : (tr.subtitleFull || '');
      html += '<div class="bbdl__tier' + (sel ? ' is-on' : '') + (tr.badge ? ' has-tag' : '') + '" data-tier="' + i + '">';
      if (tr.badge) html += '<span class="bbdl__tag">' + tr.badge + '</span>';
      html += '<label class="bbdl__head"><input type="radio" class="bbdl__radio" name="bbdl-tier" value="' + i + '"' + (sel ? ' checked' : '') + '>';
      html += '<span class="bbdl__ht"><span class="bbdl__title">' + tr.title + '</span>';
      if (sub) html += '<span class="bbdl__sub">' + sub + '</span>';
      if (cfg.freebie) html += '<span class="bbdl__free">' + (cfg.freebie.image ? '<img class="bbdl__fimg" src="' + cfg.freebie.image + '" alt="" loading="lazy">' : '') + '<span class="bbdl__fbadge">FREE</span><span>' + (tr.qty > 1 ? cfg.freebie.many : cfg.freebie.one) + '</span></span>';
      if (cfg.freeShip && tr.qty > 1) html += '<span class="bbdl__free"><span class="bbdl__fbadge">FREE</span><span>' + cfg.freeShip + '</span></span>';
      html += '</span><span class="bbdl__pr"><span class="bbdl__price">' + money(p) + '</span>';
      if (on && tr.compareAt && tr.compareAt > p) html += '<span class="bbdl__was">' + money(tr.compareAt) + '</span>';
      html += '</span></label><div class="bbdl__body">';
      if (cfg.variants.length > 1) {
        for (var u = 0; u < tr.qty; u++) {
          html += '<div class="bbdl__pick"><div class="bbdl__pickLabel">' + (tr.qty > 1 ? (cfg.unitWord || 'Item') + ' ' + (u + 1) : (cfg.pickLabel || 'Choose')) + '</div>';
          html += '<select class="bbdl__select" data-unit="' + u + '">' + unitOptions(state.picks[u]) + '</select></div>';
        }
      }
      if (cfg.addons && cfg.addons.length) {
        html += '<div class="bbdl__addons">';
        cfg.addons.forEach(function (a) {
          html += '<label class="bbdl__addon"><input type="checkbox" class="bbdl__cb" data-addon="' + a.id + '"' + (state.addons[a.id] ? ' checked' : '') + '>';
          if (a.image) html += '<img class="bbdl__thumb" src="' + a.image + '" alt="" loading="lazy">';
          html += '<span class="bbdl__an">+ ' + a.title + (a.note ? '<small class="bbdl__anote">' + a.note + '</small>' : '') + '</span><span class="bbdl__ap">' + money(a.price);
          if (a.compareAt && a.compareAt > a.price) html += '<s>' + money(a.compareAt) + '</s>';
          html += '</span></label>';
        });
        html += '</div>';
      }
      html += '</div></div>';
    });
    html += '<div class="bbdl__total"><span>' + (cfg.totalLabel || 'Total') + '</span><b data-total></b></div>';
    html += '<button type="button" class="bbdl__cta">' + (cfg.ctaLabel || 'Add to cart') + '</button>';
    html += '<p class="bbdl__err">' + (cfg.errorText || 'Please choose an option for every item.') + '</p>';
    root.innerHTML = html;
    paintTotal();
  }
  function paintTotal() { var el = root.querySelector('[data-total]'); if (el) el.textContent = money(total()); }
  function tick() {
    var on = dealOn();
    if (on !== wasActive) { wasActive = on; render(); }
    var el = root.querySelector('[data-deal]'); if (el) el.innerHTML = timerText();
    if (!on && ticker) { clearInterval(ticker); ticker = null; }
  }
  function ready() { if (cfg.variants.length <= 1) return true; var t = tier(); for (var i = 0; i < t.qty; i++) if (!state.picks[i]) return false; return true; }
  function onChange(e) {
    var el = e.target;
    if (el.name === 'bbdl-tier') { state.tier = parseInt(el.value, 10); render(); return; }
    if (el.hasAttribute('data-unit')) { state.picks[parseInt(el.getAttribute('data-unit'), 10)] = el.value; root.classList.remove('has-error'); return; }
    if (el.hasAttribute('data-addon')) { state.addons[el.getAttribute('data-addon')] = el.checked; paintTotal(); }
  }
  function codeFor(t) { return (cfg.deal && dealOn() && cfg.deal.codes && cfg.deal.codes[String(t.qty)]) || ''; }
  function addToCart() {
    var btn = root.querySelector('.bbdl__cta');
    if (!ready()) { root.classList.add('has-error'); return; }
    root.classList.remove('has-error'); btn.disabled = true;
    var t = tier(), items = [], counts = {};
    if (cfg.variants.length > 1) { for (var i = 0; i < t.qty; i++) counts[state.picks[i]] = (counts[state.picks[i]] || 0) + 1; }
    else { counts[cfg.variants[0].id] = t.qty; }
    Object.keys(counts).forEach(function (id) { items.push({ id: Number(id), quantity: counts[id] }); });
    (cfg.addons || []).forEach(function (a) { if (state.addons[a.id]) items.push({ id: Number(a.id), quantity: 1 }); });
    var code = codeFor(t);
    fetch(cfg.routes.cartAdd, { method: 'POST', headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' }, body: JSON.stringify({ items: items }) })
      .then(function (r) { return r.json(); })
      .then(function () {
        if (!cfg.deal) return null;
        return fetch('/cart/update.js', { method: 'POST', headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' }, body: JSON.stringify({ discount: code }) });
      })
      .then(function () { window.location.href = cfg.afterAdd === 'cart' ? cfg.routes.cart : cfg.routes.checkout; })
      .catch(function () { btn.disabled = false; root.classList.add('has-error'); });
  }
  function startDeal() {
    if (!cfg.deal) return;
    var key = cfg.deal.key || 'bbdl_deal', now = Date.now(), saved = 0;
    try { saved = parseInt(localStorage.getItem(key), 10) || 0; } catch (e) {}
    if (saved) { deadline = saved; }
    else { deadline = now + (cfg.deal.seconds || 0) * 1000; try { localStorage.setItem(key, String(deadline)); } catch (e) {} }
    wasActive = dealOn();
    if (wasActive) ticker = setInterval(tick, 1000);
  }
  window.__bbdlDeal = function () { return { on: dealOn(), deadline: deadline }; };
  function boot() {
    root = document.getElementById(MOUNT_ID); var node = document.getElementById(CONFIG_ID);
    if (!root || !node) return;
    try { cfg = JSON.parse(node.textContent); } catch (e) { return; }
    if (!cfg.tiers || !cfg.tiers.length || !cfg.variants || !cfg.variants.length) return;
    var first = cfg.variants.filter(function (v) { return v.available; })[0] || cfg.variants[0];
    var maxQty = cfg.tiers.reduce(function (m, t) { return Math.max(m, t.qty); }, 1);
    state.picks = new Array(maxQty).fill(first.id);
    (cfg.addons || []).forEach(function (a) { state.addons[a.id] = !!a.checked; });
    startDeal();
    root.classList.add('bbdl'); render();
    root.addEventListener('change', onChange);
    root.addEventListener('click', function (e) { if (e.target.closest && e.target.closest('.bbdl__cta')) addToCart(); });
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', boot); else boot();
})();
